import React from "react";
import { Box, IconButton, Tooltip, Typography } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import ImageIcon from "@material-ui/icons/Image";
import { useTranslation } from "react-i18next";

export function LocalImageUpload({ logo, selectFile, deleteImage }) {
    const { t } = useTranslation();
    async function onChangeInputFile(e) {
        if (e.target.files.length) {
            selectFile(e.target.files[0]);
        }
    }

    return (
        <Box
            style={{
                position: "relative",
                width: 200,
                maxWidth: 200,
                maxHeight: 70,
                height: 70,
            }}
        >
            <Box width="100%" height="100%">
                <input
                    accept="image/*"
                    style={{ display: "none" }}
                    id="select-logo"
                    type="file"
                    onChange={onChangeInputFile}
                />
                <Box
                    width="100%"
                    height="100%"
                    style={{
                        position: "relative",
                        borderWidth: 3,
                        borderStyle: "dashed",
                        borderRadius: 5,
                        borderColor: "#999999",
                    }}
                >
                    <label
                        htmlFor="select-logo"
                        style={{
                            display: "block",
                            width: "100%",
                            height: "100%",
                        }}
                    >
                        <Box
                            width="100%"
                            height="100%"
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                        >
                            {logo ? (
                                <Tooltip title={t('flashboard.config.tooltip.add-logo')}>
                                    <img
                                        src={logo}
                                        style={{
                                            maxHeight: 50,
                                            maxWidth: 190,
                                        }}
                                        alt="Logo flashboard"
                                    />
                                </Tooltip>
                            ) : (
                                <Box
                                    padding={2}
                                    display="flex"
                                    justifyContent="center"
                                    flexDirection="column"
                                    alignItems="center"
                                >
                                    <ImageIcon
                                        style={{
                                            color: "#999999",
                                        }}
                                    />
                                    <Typography
                                        align="center"
                                        style={{
                                            color: "#999999",
                                        }}
                                    >
                                        {t('flashboard.config.add-logo')}
                                    </Typography>
                                </Box>
                            )}
                        </Box>
                    </label>
                </Box>
            </Box>
            {logo && (
                <Box
                    style={{
                        position: "absolute",
                        top: 0,
                        right: 0,
                    }}
                >
                    <Tooltip title={t('flashboard.config.tooltip.remove-logo')}>
                        <IconButton onClick={deleteImage}>
                            <CloseIcon color="error" />
                        </IconButton>
                    </Tooltip>
                </Box>
            )}
        </Box>
    );
}
